import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { TipoUsuario } from '../../enum/TipoUsuario';
import { AuthService } from '../../services/auth';
import { NotificationService } from '../../services/notification';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  router = inject(Router);
  authService = inject(AuthService);
  notification = inject(NotificationService);
  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
    return this.authService.tipoUsuario$.pipe(
      take(1),
      map((tipoUsuario) => {
        if (this.hasRole(route, tipoUsuario)) {
          return true;
        }

        this.showUnauthorizedNotification();

        return this.router.parseUrl('inicio');
      })
    );
  }

  private extractRoles(route: ActivatedRouteSnapshot): TipoUsuario[] {
    return (route.data['roles'] as TipoUsuario[]) ?? [];
  }

  private hasRole(
    route: ActivatedRouteSnapshot,
    tipoUsuario: TipoUsuario | null
  ): boolean {
    return this.extractRoles(route).some((role) => role === tipoUsuario);
  }

  private showUnauthorizedNotification(): void {
    this.notification.info('Você não tem permissão para acessar essa página.');
  }
}
